import Connection from "../Connection.js";

const parametros = {
  get: async function () {
    return await Connection.get(`parametro/1`)
  }
};

export default parametros
